import { Phone, MessageCircle, CalendarDays } from "lucide-react";
import { business, whatsappLink } from "@/lib/site";
import { useBooking } from "@/components/BookingContext";

export const MobileStickyBar = () => {
  const { openBooking } = useBooking();
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="xl:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-border grid grid-cols-3 shadow-[0_-4px_16px_-4px_rgba(11,31,58,0.15)]"
    >
      <a
        href={`tel:${business.phoneTel}`}
        data-testid="sticky-call"
        className="flex flex-col items-center justify-center gap-1 py-2.5 text-navy active:bg-soft transition-colors"
      >
        <Phone className="h-5 w-5" />
        <span className="text-[11px] font-semibold">Call Now</span>
      </a>
      <a
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp"
        className="flex flex-col items-center justify-center gap-1 py-2.5 text-white bg-[#25D366] active:opacity-90 transition-opacity"
      >
        <MessageCircle className="h-5 w-5" />
        <span className="text-[11px] font-semibold">WhatsApp</span>
      </a>
      <button
        onClick={openBooking}
        data-testid="sticky-book"
        className="flex flex-col items-center justify-center gap-1 py-2.5 text-white bg-brand-orange active:bg-brand-orange-dark transition-colors"
      >
        <CalendarDays className="h-5 w-5" />
        <span className="text-[11px] font-semibold">Book</span>
      </button>
    </div>
  );
};

export default MobileStickyBar;
